import { Link } from 'react-router-dom';
import { NewsletterSignup } from '@/components/shared/NewsletterSignup';

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground">
      {/* Newsletter CTA */}
      <div className="border-b border-primary-foreground/10">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-xl mx-auto text-center">
            <h3 className="font-display text-2xl font-bold mb-2">
              Stay in the Loop
            </h3>
            <p className="text-primary-foreground/80 mb-6">
              Get the latest automotive news, reviews, and insights delivered to your inbox.
            </p>
            <NewsletterSignup variant="footer" />
          </div>
        </div>
      </div>

      {/* Footer links */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h4 className="font-semibold mb-4">Content</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/news" className="hover:text-primary-foreground">Latest News</Link></li>
              {/* <li><Link to="/reviews" className="hover:text-primary-foreground">Reviews</Link></li> */}
              <li><Link to="/events" className="hover:text-primary-foreground">Events</Link></li>
              {/* <li><Link to="/videos" className="hover:text-primary-foreground">Videos</Link></li> */}
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Categories</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/news?category=electric-vehicles" className="hover:text-primary-foreground">Electric Vehicles</Link></li>
              <li><Link to="/news?category=autonomous-driving" className="hover:text-primary-foreground">Autonomous Driving</Link></li>
              <li><Link to="/news?category=technology" className="hover:text-primary-foreground">Technology</Link></li>
              <li><Link to="/news?category=manufacturing" className="hover:text-primary-foreground">Manufacturing</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/about" className="hover:text-primary-foreground">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-primary-foreground">Contact</Link></li>
              <li><Link to="/advertise" className="hover:text-primary-foreground">Advertise</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Partners</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/dealers" className="hover:text-primary-foreground">For Dealers</Link></li>
              <li><Link to="/dealers/register" className="hover:text-primary-foreground">Become a Partner</Link></li>
              <li><Link to="/dealer/login" className="hover:text-primary-foreground">Dealer Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/privacy" className="hover:text-primary-foreground">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-primary-foreground">Terms of Service</Link></li>
              <li>
                <button 
                  onClick={() => {
                    // Dispatch event to open cookie settings
                    window.dispatchEvent(new CustomEvent('open-cookie-settings'));
                  }}
                  className="hover:text-primary-foreground cursor-pointer"
                >
                  Cookie Preferences
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-primary-foreground/10 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-primary-foreground/60">
            © {new Date().getFullYear()} Auto News Weekly. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <span className="font-display text-xl font-bold">Auto News Weekly</span>
          </div>
        </div>
      </div>
    </footer>
  );
}